import React from 'react'
import AppBar from '../../components/AppBar/AppBar'
import Chart from '../../components/chart/Chart'
import Featured from '../../components/featured/Featured'
import NavBar from '../../components/navbar/Navbar'
import Sidebar from '../../components/sidebar/Sidebar'
// import Table from '../../components/table/Table'
import Widget from '../../components/widget/Widget'
import "./home.scss"

const Home = () => {

  var month = new Date().getMonth() + 1;

  // console.log(month);
  
  return (
    <div className='flex'>
        <AppBar/>
        <NavBar/>
        <div className='mt-12 justify-center ml-8'>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 widgets lg:ml-60 mt-10">
            <Widget type="total"/>
            <Widget type="male"/>
            <Widget type="female"/>
            <Widget type="license"/>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 charts lg:ml-60 ml-0">
            <Featured/>
            <Chart title="Last 6 Months (Registered drivers)" aspect={2 / 1}/>
          </div>
        </div>
    </div>
  )
}

export default Home